import React, { useEffect, useRef, useState } from 'react';
// import noneimg from '@/assets/imgs/placeholderimg.png';
import noneimg from '@/assets/imgs/default_img.png';
import styles from './index.less';

/**
 *
 * @param props {iconCls,iconStyles, textStyles}
 */

export interface typeProps {
  src?: string;
  /** 滚动容器ID */
  container?: string;
}

const DFImage = (props: typeProps) => {
  const [imgSrc, setImgSrc] = useState('');
  const imgDom = useRef();

  const path = props.src;

  const lazyLoad = () => {
    if (isShowDom() && path) {
      setImgSrc(path);
    }
  };
  function isShowDom() {
    try {
      let item: any = imgDom.current;
      var bound = item.getBoundingClientRect();
      var clientHeight = window.innerHeight;
      return bound.top + 30 <= clientHeight;
    } catch (e) {
      return true;
    }
  }

  useEffect(() => {
    lazyLoad();
    if (props.container) {
      const scrollDiv: any = document.getElementById(props.container);
      //绑定事件
      scrollDiv.addEventListener('scroll', function () {
        lazyLoad();
      });
    }
  }, []);

  return (
    <img ref={imgDom} {...props} className={`${styles[imgSrc ? '' : 'defaultImg']}`} src={imgSrc} onError={(e: any) => { e.target.onerror = null; e.target.src = noneimg; e.target.className=`${styles.defaultImg}`; }} />
  );
};
export default DFImage;
